export default __webpack_public_path__ + "0b859dd3339bee78fa65cde53773c909.png";